import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-zinc-950 text-white flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <Helmet>
        <title>404 - Page Not Found | LeadGen AI</title>
        <meta name="description" content="The page you are looking for does not exist." />
      </Helmet>
      <div className="text-center max-w-lg">
        {/* Icon */}
        <div className="text-6xl mb-8">🔍</div>

        {/* 404 Text with Gradient */}
        <h1 className="text-8xl sm:text-9xl font-bold bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent mb-4">
          404
        </h1>

        {/* Page Not Found */}
        <h2 className="text-2xl font-bold text-white mb-4">
          Page Not Found
        </h2>

        {/* Description */}
        <p className="text-gray-400 mb-8 text-lg">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg px-6 py-3 transition-colors inline-block"
          >
            Go Home
          </Link>
          <Link
            to="/dashboard"
            className="bg-zinc-800 hover:bg-zinc-700 text-white font-medium border border-dark-600 rounded-lg px-6 py-3 transition-colors inline-block"
          >
            Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
